/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Counts_Reports_OneInputs */



/**
* | output |
* | --- |
* | "1 report in this month" |
*
* @param {Partner_Billing_Board_Counts_Reports_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_counts_reports_one = /** @type {((inputs?: Partner_Billing_Board_Counts_Reports_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Counts_Reports_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("1 Bericht in diesem Monat")
	return /** @type {LocalizedString} */ ("1 report in this month")
});